import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a DOM manipulation error (usually from Google Translate)
    if (error instanceof DOMException && 
        (error.name === 'NotFoundError' || 
         error.message?.includes('removeChild'))) {
      // Don't show error UI for these - just ignore them
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log only non-Google-Translate errors
    if (!(error instanceof DOMException && 
          (error.name === 'NotFoundError' || 
           error.message?.includes('removeChild')))) {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <div className="text-center">
            <h2 className="text-xl font-bold text-slate-800 mb-2">
              Algo deu errado
            </h2>
            <p className="text-slate-600 mb-4">
              Ocorreu um erro inesperado.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
